import i18n from '@/i18n';

/**
 * Human-readable label for a KeyboardEvent.code / mouse-button pseudo-code,
 * extracted from VoicePreferencesTab so the push-to-talk binding display is
 * testable. Pure: maps a raw code to its user-facing label.
 */
export function formatKeyCode(code: string): string {
  if (!code) return i18n.t('set2.keybind.unset');
  if (code.startsWith('Mouse')) {
    const mouse: Record<string, string> = {
      Mouse1: i18n.t('set2.keybind.mouseMiddle'),
      Mouse3: i18n.t('set2.keybind.mouseSide1'),
      Mouse4: i18n.t('set2.keybind.mouseSide2'),
    };
    return mouse[code] ?? i18n.t('set2.keybind.mouseN', { n: code.slice(5) });
  }
  if (code === 'Space') return i18n.t('set2.keybind.space');
  if (code.startsWith('Key')) return code.slice(3);
  if (code.startsWith('Digit')) return code.slice(5);
  if (code.startsWith('Numpad')) return 'Num ' + code.slice(6);
  const named: Record<string, string> = {
    ControlLeft: 'Ctrl', ControlRight: i18n.t('set2.keybind.ctrlRight'),
    ShiftLeft: 'Shift', ShiftRight: i18n.t('set2.keybind.shiftRight'),
    AltLeft: 'Alt', AltRight: i18n.t('set2.keybind.altRight'),
    MetaLeft: 'Win', MetaRight: 'Win',
    ArrowUp: '↑', ArrowDown: '↓', ArrowLeft: '←', ArrowRight: '→',
    Enter: 'Enter', Tab: 'Tab', Backquote: '`', CapsLock: 'Caps',
  };
  return named[code] ?? code;
}
